// "Peak concurrent sessions" cell for the runtime stats grid.
//
// Reads from `aggregates.peakConcurrent` so the operator can answer
// "what was the worst spike inside the visible window" without scrubbing
// the chart. The "Active sessions" cell stays for "right now".

import { formatRelative } from "@veil/ui/lib/format";

interface Props {
	peak: number;
	peakAt: string | null;
	rangeLabel: string;
}

export function PeakConcurrentStat({ peak, peakAt, rangeLabel }: Props) {
	return (
		<div>
			<div className="text-xs uppercase text-muted-foreground">
				Peak concurrent
			</div>
			<div className="font-semibold text-lg tabular-nums">{peak}</div>
			<div className="text-xs text-muted-foreground">
				{peakAt
					? `${formatRelative(peakAt)}, over ${rangeLabel}`
					: `over ${rangeLabel}`}
			</div>
		</div>
	);
}
